"use strict";

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var DropdownRegistry = function () {
  function DropdownRegistry() {
    _classCallCheck(this, DropdownRegistry);

    this._links = [];
    this._currentFocusIndex = -1;
  }

  DropdownRegistry.prototype.addChild = function addChild(child) {
    this._links.push(child);
  };

  DropdownRegistry.prototype.removeChild = function removeChild(child) {
    this._links.splice(this._links.indexOf(child), 1);
  };

  DropdownRegistry.prototype._focusChildAt = function _focusChildAt(index) {
    if (this._links[index]) {
      this._links[index].focus();
    }
  };

  DropdownRegistry.prototype.focusNext = function focusNext() {
    this._focusChildAt(this._currentFocusIndex + 1);
  };

  DropdownRegistry.prototype.focusPrev = function focusPrev() {
    this._focusChildAt(this._currentFocusIndex - 1);
  };

  DropdownRegistry.prototype.setFocusedChild = function setFocusedChild(child) {
    this._currentFocusIndex = this._links.indexOf(child);
  };

  DropdownRegistry.prototype.removeFocusedChild = function removeFocusedChild(child) {
    this._currentFocusIndex = -1;
  };

  return DropdownRegistry;
}();

module.exports = DropdownRegistry;